export enum NotificationCategory {
  TODO = 'TODO',
  GENERAL = 'GENERAL',
  TO_DO_UPDATE = 'TO_DO_UPDATE',
  CONFIRMATION_UPDATE = 'CONFIRMATION_UPDATE'
}

export default NotificationCategory;
